import React, { useContext } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { AuthContext } from "context/AuthContext";
import MfaEnrolment from "components/mfa/MfaEnrolment";
import logo from "../assets/images/logo.png";

// The forced gate. An admin who is signed in but hasn't enrolled is sent here
// by ProtectedRoute and by the axios interceptor, and every guarded API route
// answers MFA_REQUIRED until they finish — so there is deliberately no nav, no
// cancel, and nowhere else to go from this page except signing out.
const MfaSetup = () => {
  const { isAuthenticated, loading, mfaEnrolled, logout, refresh } =
    useContext(AuthContext);
  const navigate = useNavigate();

  if (loading) {
    return (
      <div className="h-screen flex items-center justify-center">
        <i className="fa-solid fa-spinner animate-spin"></i>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // Already enrolled — nothing to do here. Reached by typing the URL, or by
  // landing back on it after finishing.
  if (mfaEnrolled) {
    return <Navigate to="/" replace />;
  }

  const handleComplete = async () => {
    await refresh();
    navigate("/");
  };

  const handleSignOut = async () => {
    await logout();
    navigate("/login");
  };

  return (
    <div className="min-h-screen py-8 px-4 flex items-center justify-center">
      <div className="border border-mediumgray p-8 rounded-md w-full max-w-md">
        <div className="flex justify-center items-center w-full pb-6">
          <img src={logo} alt="Beleef" className="w-[150px] h-auto" />
        </div>

        <h4 className="text-center mb-2">Set up two-factor authentication</h4>
        <p className="text-sm text-darkergray text-center mb-6">
          Required for every admin account. You'll need it once now, and a code
          each time you sign in.
        </p>

        <MfaEnrolment onComplete={handleComplete} />

        <button
          type="button"
          onClick={handleSignOut}
          className="w-full mt-6 text-sm text-darkergray underline"
        >
          Sign out instead
        </button>
      </div>
    </div>
  );
};

export default MfaSetup;
